import { db } from '../../../config/firebase-config';
import {
    getDocs,
    collection,
    doc,
    getDoc
} from 'firebase/firestore';

let TABLE_NAME = "PDFTemplates"; 

const formCollectionRef = collection(db, TABLE_NAME);

//Get All Items
export const getAllPDFTemplates = async () => {
    try {
        const data = await getDocs(formCollectionRef);
        const filteredData = data.docs.map((doc) => ({
            ...doc.data(),
            Id: doc.id
        }))
        return filteredData;
    } catch (error) {
        throw error;
    }
}

// Get a specific PDF template by docId
export const fetchPDFTemplateById = async (docId) => {
    try {
        const docRef = doc(db, TABLE_NAME, docId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return { ...docSnap.data(), Id: docSnap.id };
        } else {
            console.log("No such document!");
            return null;
        }
    } catch (error) {
        throw error;
    }
};